<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <!-- About Section -->
      <div class="footer-section">
        <h3>AI PodLab</h3>
        <p>Il podcast su scienza e tecnologia</p>
        <div class="social-links">
          <a href="https://open.spotify.com/show/0rSrBFAHsxGwjQ3RIsQsV0" aria-label="Spotify" title="Ascoltaci su Spotify" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
            </svg>
          </a>
          <a href="https://www.spreaker.com/podcast/ai-podlab--7432883" aria-label="Spreaker" title="Ascoltaci su Spreaker" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1a4 4 0 0 0-4 4v6a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4zm-7 10a1 1 0 0 1 2 0 5 5 0 0 0 10 0 1 1 0 1 1 2 0 7 7 0 0 1-6 6.93V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-3.07A7 7 0 0 1 5 11z"/>
            </svg>
          </a>
          <a [href]="rssUrl" aria-label="RSS Feed" title="RSS Feed" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.503 20.752c0 1.794-1.456 3.248-3.251 3.248-1.796 0-3.252-1.454-3.252-3.248 0-1.794 1.456-3.248 3.252-3.248 1.795.001 3.251 1.454 3.251 3.248zm-6.503-12.572v4.811c6.05.062 10.96 4.966 11.022 11.009h4.817c-.062-8.71-7.118-15.758-15.839-15.82zm0-3.368c10.58.046 19.152 8.594 19.183 19.188h4.817c-.03-13.231-10.755-23.954-24-24v4.812z"/>
            </svg>
          </a>
        </div>
      </div>

      <!-- Navigation Links -->
      <div class="footer-section">
        <h4>Navigazione</h4>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/episodi">Episodi</a></li>
          <li><a routerLink="/categorie">Categorie</a></li>
          <li><a routerLink="/about">About</a></li>
        </ul>
      </div>

      <!-- Ascoltaci -->
      <div class="footer-section">
        <h4>Ascoltaci</h4>
        <ul>
          <li><a href="https://open.spotify.com/show/0rSrBFAHsxGwjQ3RIsQsV0" target="_blank" rel="noopener noreferrer">Spotify</a></li>
          <li><a href="https://www.spreaker.com/podcast/ai-podlab--7432883" target="_blank" rel="noopener noreferrer">Spreaker</a></li>
          <li><a [href]="rssUrl" target="_blank">RSS Feed</a></li>
        </ul>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} AI PodLab. Tutti i diritti riservati.</p>
      <p class="made-with">Made with ❤️ in Italy</p>
    </div>
  </div>
</footer>
